import {
  Box, Button, Checkbox, ClickAwayListener,
  Fade,
  FormControl, FormControlLabel, Grid, InputAdornment,
  Modal,
  Popper, Radio,
  RadioGroup,
  TextField, Typography
} from '@mui/material';
import _, { set } from 'lodash';
import moment from 'moment';
import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import { ReactComponent as CalendarIcon } from "../../assets/icons/icon_calender.svg";


import { ReactComponent as AngleDownBlackIcon } from '../../assets/icons/icon-angle-down-black.svg';
import { ReactComponent as AngleDownIcon } from '../../assets/icons/icon-angle-down.svg';
import { ReactComponent as CheckBoxCheckedIcon } from '../../assets/icons/icon-checkbox-checked.svg';
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/icon-checkbox-unchecked.svg';
import { ReactComponent as InputSearchIcon } from "../../assets/icons/icon-feather-search.svg";

import Controls from '../../components/controls/Controls';

import { ReactComponent as CloseIcon } from "../../assets/icons/icon_close.svg";
import { GREATER_LESS_THAN_FILTER, NUMBER_FILTER_TYPE } from '../../constants/filterType';
import { useDashboardContext } from '../../layouts/dashboardView/DashboardView';
import Loader from '../../pages/Loader';
import { CamelToNormalString, generateCustomDateRange } from '../../utils/Reusables';
import getDataFromCube from '../../utils/getCubeData';
import { ReactComponent as FilterIcon } from './../../assets/icons/icon-filter-sm.svg';


const NUMBER_VALUES = ["one", "two", "three", "four", "five"];

function DesktopViewSheetFilter({ editFilterComponents }) {
  const { sheetFilters, currentSheet } = useSheetFilterContext()
  return (
    <Box sx={{ flexGrow: 1 }} key={`sheetfilter`}>
      <Box className={`dashboard-view-filters-container ${sheetFilters?.filter(obj => !obj?.hidden)?.length || currentSheet?.globalFilter ? 'has-filters' : 'no-filters'}`}>
        {
          sheetFilters.map((filter) => {
            const isHidden = filter?.hidden || filter?.isCascadedHidden;
            if (isHidden && !editFilterComponents) return null;
            return (
              <SheetFilterItem
                key={`filter-item-${filter.member}-${filter._id}`}
                filter={filter}
                filterIndex={filter.filterIndex}
                editFilterComponents={editFilterComponents}
              />
            )
          })
        }
        {
          currentSheet?.globalFilter && currentSheet?.globalFilter?.dateRangeType
            ? (
              <GlobalDateFilter key={currentSheet?._id}/>
            )
            : null
        }
      </Box>
    </Box>
  )
}


const getTimePeriodValue = (timePeriodString) => {

  switch (timePeriodString) {
    case 'Today':
      return {
        startDate: moment().startOf('day').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().endOf('day').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Yesterday':
      return {
        startDate: moment().subtract(1, 'day').startOf('day').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().subtract(1, 'day').endOf('day').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'This Week':
      return {
        startDate: moment().startOf('week').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().endOf('week').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Last Week':
      return {
        startDate: moment().subtract(1, 'week').startOf('week').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().subtract(1, 'week').endOf('week').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'This Month':
      return {
        startDate: moment().startOf('month').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().endOf('month').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Last Month':
      return {
        startDate: moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'This Quarter':
      return {
        startDate: moment().startOf('quarter').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().endOf('quarter').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Last Quarter':
      return {
        startDate: moment().subtract(1, 'quarter').startOf('quarter').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().subtract(1, 'quarter').endOf('quarter').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'This Year':
      return {
        startDate: moment().startOf('year').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().endOf('year').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Last Year':
      return {
        startDate: moment().subtract(1, 'year').startOf('year').format('YYYY/MM/DD HH:mm:ss'),
        endDate: moment().subtract(1, 'year').endOf('year').format('YYYY/MM/DD HH:mm:ss')
      };

    case 'Custom':
      return {
        startDate: null,
        endDate: null,
        isCustom: true
      };

    default:
      return {
        startDate: null,
        endDate: null
      };
  }
};

function GlobalDateFilter() {
  const { updateSheet ,currentSheet,dashboardState} = useDashboardContext();
  const [filterInputEl, setFilterInputEl] = useState(null);
  const [filterInputOpen, setFilterInputOpen] = useState(false);
  const filterInputId = filterInputOpen ? 'global-date-filter-popover' : undefined;
  const selectFiltersInput = useRef(null);
  const [timePeriodValue, setTimePeriodValue] = useState(
    currentSheet?.globalFilter?.dateFilterProps?.selectedTimePeriod || null
  );
  const [filterLabelValue, setFilterLabelValue] = useState(null);
  
  const [values, setValues] = useState(currentSheet?.globalFilter?.values || []);

  const timePeriodOptions = currentSheet?.globalFilter?.selectedTimePeriods || [];


  useEffect(() => {
    if(currentSheet?.globalFilter?.values && currentSheet?.globalFilter?.values.length > 0) {
      return;
    }
    else if (currentSheet?.globalFilter?.dateRangeType === 'TIME_PERIOD') {
      setFilterLabelValue('Time Period');
    } else if (currentSheet?.globalFilter?.dateRangeType === 'DATE_AND_TIME') {
      setFilterLabelValue('Select Date & Time');
    } else if (currentSheet?.globalFilter?.dateRangeType === 'DATE') {
      setFilterLabelValue('Select Date Range');
    } else {
      setFilterLabelValue('Select Date Range');
    }
  }, [currentSheet?.globalFilter]);

  useEffect(() => {
    if (values?.[0] && values?.[1]) {
      const dateFormat = currentSheet?.globalFilter?.dateRangeType === 'DATE_AND_TIME' ? 'DD/MMM/yyyy HH:mm' : 'DD/MMM/yyyy';
      const startDate = moment(values[0]).format(dateFormat);
      const endDate = moment(values[1]).format(dateFormat);
      updateSheet({sheetIndex: dashboardState.currentSheetIndex, sheet: {
        ...currentSheet,
        globalFilter: {
          ...currentSheet.globalFilter,
          values: values,
        }
      }});
      setFilterLabelValue(`${startDate} - ${endDate}`);
    }
  }, [values, currentSheet?.globalFilter?.dateRangeType]);

  const handleFilterInputClick = (event) => {
    if (event.currentTarget !== filterInputEl) {
      setFilterInputEl(event.currentTarget);
    }
    setFilterInputOpen(!filterInputOpen);
  };

  const handleFilterInputClose = () => {
    setFilterInputEl(null);
    setFilterInputOpen(false);
  };

  const handleDateFilter = (date, type) => {
    const newValues = [...values];
    
    if (type === 'startDate') {
      if (date) {
        if (moment(date).isValid() === false) {
          toast.error('Please select valid start date');
          return;
        }
        if (newValues[1] && moment(date).isAfter(moment(newValues[1]))) {
          toast.error('Start date should be less than end date');
          return;
        }
        newValues[0] = moment(date).format('YYYY/MM/DD HH:mm:ss');
      } else {
        newValues[0] = null;
      }
    }
    
    if (type === 'endDate') {
      if (date) {
        if (moment(date).isValid() === false) {
          toast.error('Please select valid end date');
          return;
        }
        if (newValues[0] && moment(date).isBefore(moment(newValues[0]))) {
          toast.error('End date should be greater than start date');
          return;
        }
        const isDateTime = currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME";
        newValues[1] = date && !isDateTime 
          ? moment(date).endOf('day').format('YYYY/MM/DD HH:mm:ss')
          : moment(date).format('YYYY/MM/DD HH:mm:ss');
      } else {
        newValues[1] = null;
      }
    }

    setValues(newValues);
  };

  const handleTimePeriodFilter = (selectedPeriod) => {
    setTimePeriodValue(selectedPeriod);
    
    if (selectedPeriod === 'Custom') {
      setValues([]);
      setFilterLabelValue('Select Date Range');
      return;
    }

    const { startDate, endDate } = getTimePeriodValue(selectedPeriod);
    setValues([startDate, endDate]);
  };

  const resetForm = () => {
    if (currentSheet?.globalFilter?.dateRangeType === 'TIME_PERIOD') {
      setFilterLabelValue('Time Period');
    } else if (currentSheet?.globalFilter?.dateRangeType === 'DATE_AND_TIME') {
      setFilterLabelValue('Select Date & Time');
    } else if (currentSheet?.globalFilter?.dateRangeType === 'DATE') {
      setFilterLabelValue('Select Date Range');
    } else {
      setFilterLabelValue('Select');
    }

    setTimePeriodValue(null);
    setValues([]);
    handleFilterInputClose();
  };


  const applyForm = () => {
    if(currentSheet && currentSheet?.globalFilter) {
      const currentSheetCopy = structuredClone(currentSheet);
      const selectedReports = currentSheetCopy?.globalFilter?.selectedReports || [];
      const reportIdFilterMap = {};
      selectedReports?.forEach(selectedReport=>{
        reportIdFilterMap[selectedReport.reportId]={
          displayName : selectedReport?.selectedField?.displayName,
          member : selectedReport?.selectedField?.fieldName,
          operator : "inDateRange",
          type : selectedReport?.selectedField?.fieldType,
          values,
          _id:selectedReport?.selectedField?.fieldId,
        }
      })
      currentSheetCopy?.reports.forEach(report=>{
        if(reportIdFilterMap[report._id]){
          report.reportFilters = report?.reportFilters?.filter(filter => filter._id !== reportIdFilterMap[report._id]._id);
          report?.reportFilters.push(reportIdFilterMap[report._id]);
        }
      })

      updateSheet({
        sheetIndex: dashboardState.currentSheetIndex,
        sheet: currentSheetCopy,
      });
    }
  };

  const MultiSelectRow = ({ index, style, data }) => {
    const item = data[index];
    return (
      <div style={style} key={item}>
        <FormControlLabel 
          style={{ padding: '0 16px', width: '100%' }} 
          title={item} 
          className="menu-item menu-item-light" 
          label={item}
          control={
            <Radio 
              className="form_checkbox" 
              size="small"
              checked={timePeriodValue === item}
              value={item}
              onChange={(e) => setTimePeriodValue(e.target.value)} 
            />
          } 
        />
      </div>
    );
  };

  return (
    <Box className={`dashboard-filters-view-item filter-enabled`}>
      <Box className="dashboard-filter-heading" sx={{ mb: 1 }}>
        <Typography 
          variant="body2" 
          className="dashboard-filter-title"
          sx={{ 
            fontWeight: 600,
            color: '#202124',
            fontSize: '14px',
            marginBottom: '8px'
          }}
        >
          Global Date Filter
        </Typography>
      </Box>
      
      <Box>
        <FormControl className="" variant="outlined" sx={{ width: '100%' }} size="small">
          <Grid container mt={0}>
            <Grid item>
              <Box 
                sx={{ userSelect: 'none' }} 
                className={`select_filters_input ` + (values?.length ? `has-value` : ``)}
                id={`target-global-date-filter`} 
                ref={selectFiltersInput} 
                onClick={handleFilterInputClick}
              >
                <Box className="select_filters_input_item dashboard-filters-input" display="flex" alignItems="center">
                  <Typography
                    variant="body2"
                    className="form_multi_input"
                  >
                    {filterLabelValue ?? "Global Date Filter"}
                  </Typography>
                </Box>
                <Box className="select_filters_input_item filters-dropdown-icon">
                  {values?.length ? <AngleDownBlackIcon /> : <AngleDownIcon />}
                </Box>
              </Box>

              {filterInputOpen ? (
                <ClickAwayListener onClickAway={handleFilterInputClose}>
                  <Popper
                    id={filterInputId}
                    open={filterInputOpen}
                    anchorEl={selectFiltersInput.current}
                    onClose={handleFilterInputClose}
                    placement="bottom-start"
                    disablePortal={false}
                    sx={{ zIndex: 10 }}
                  >
                    <Box className="filter-item-options dashboard-filters-view-popover quick-filter-popover">
                      <Box className="filters-dropdown-item quick-filter-dd" sx={{ width: "100%" }}>
                        
                        {currentSheet?.globalFilter?.dateRangeType === "TIME_PERIOD" ? (
                          <Grid pt={1}>
                            <RadioGroup
                              name="global-date-filter-radio-group"
                              value={timePeriodValue}
                              onChange={(e) => handleTimePeriodFilter(e.target.value)}
                            >
                              <div
                                className={
                                  `virtual-filter-div ` +
                                  (timePeriodOptions?.length
                                    ? "filter-data-exists"
                                    : ``)
                                }
                              >
                                <AutoSizer>
                                  {({ height, width }) => (
                                    <List
                                      className="List"
                                      height={
                                        timePeriodOptions?.length
                                          ? height
                                          : 20
                                      }
                                      itemCount={timePeriodOptions?.length}
                                      width={width - 6}
                                      itemData={timePeriodOptions}
                                      itemSize={35}
                                    >
                                      {MultiSelectRow}
                                    </List>
                                  )}
                                </AutoSizer>
                              </div>
                            </RadioGroup>
                          </Grid>
                        ) : null}

                        {(currentSheet?.globalFilter && timePeriodValue === "Custom") ||
                        currentSheet?.globalFilter?.dateRangeType === "DATE" ||
                        currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ? (
                          <Box
                            className="filters-dropdown-item-content"
                            sx={{ p: "1.25rem !important" }}
                          >
                            <Grid container spacing={2}>
                              <Grid xs={12} md={6} item>
                                <Typography
                                  className="report-form-label"
                                  variant="subtitle2"
                                >
                                  Start {currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ? "Date & Time" : "Date"}
                                </Typography>
                                <DatePicker
                                  autoComplete="off"
                                  showTimeSelect={
                                    currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME"
                                  }
                                  dateFormat={currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ? "dd-MM-yyyy HH:mm" : "dd-MM-yyyy"}
                                  showYearDropdown={true}
                                  showMonthDropdown={true}
                                  dropdownMode="select"
                                  className="report_form_ui_input_date er-input-filter"
                                  selected={
                                    values?.[0] 
                                      ? new Date(values[0]) 
                                      : null
                                  }
                                  onChange={(e) => handleDateFilter(e, "startDate")}
                                  isClearable
                                  placeholderText="Select Date"
                                  customInput={
                                    <TextField
                                      className={
                                        `report_form_ui_input_date er-input-filter ` +
                                        (values?.[0] ? `has-value` : ``)
                                      }
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="start">
                                            <CalendarIcon />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  }
                                />
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <Typography
                                  className="report-form-label"
                                  variant="subtitle2"
                                >
                                  End {currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ? "Date & Time" : "Date"}
                                </Typography>
                                <DatePicker
                                  autoComplete="off"
                                  dateFormat={currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ? "dd-MM-yyyy HH:mm" : "dd-MM-yyyy"}
                                  showYearDropdown={true}
                                  showMonthDropdown={true}
                                  dropdownMode="select"
                                  showTimeSelect={
                                    currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME"
                                  }
                                  className="report_form_ui_input_date er-input-filter"
                                  selected={
                                    values?.[1] 
                                      ? new Date(values[1]) 
                                      : null
                                  }
                                  onChange={(e) => handleDateFilter(e, "endDate")}
                                  isClearable
                                  placeholderText="Select Date"
                                  customInput={
                                    <TextField
                                      className={
                                        `report_form_ui_input_date er-input-filter ` +
                                        (values?.[1] ? `has-value` : ``)
                                      }
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="start">
                                            <CalendarIcon />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        ) : null}

                        {currentSheet?.globalFilter?.dateRangeType === "TIME_PERIOD" &&
                        timePeriodValue !== "Custom" ? (
                          <Grid item xs={12} className="filters-popover-footer">
                            <Box sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
                              <Controls.Button
                                className="report_form_ui_btn cancel cancel2 mr-2"
                                color="secondary"
                                text="Clear All"
                                onClick={resetForm}
                              />
                              <Controls.Button
                                className="report_form_ui_btn submit submit2"
                                type="submit"
                                text="Apply"
                                onClick={applyForm}
                              />
                            </Box>
                          </Grid>
                        ) : null}

                        {(currentSheet?.globalFilter?.dateRangeType === "DATE" ||
                        currentSheet?.globalFilter?.dateRangeType === "DATE_AND_TIME" ||
                        timePeriodValue === "Custom") ? (
                          <Grid item xs={12} className="filters-popover-footer">
                            <Box sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
                              <Controls.Button
                                className="report_form_ui_btn cancel cancel2 mr-2"
                                color="secondary"
                                text="Clear All"
                                onClick={resetForm}
                              />
                              <Controls.Button
                                className="report_form_ui_btn submit submit2"
                                type="submit"
                                text="Apply"
                                onClick={applyForm}
                              />
                            </Box>
                          </Grid>
                        ) : null}

                      </Box>
                    </Box>
                  </Popper>
                </ClickAwayListener>
              ) : null}
            </Grid>
          </Grid>
        </FormControl>
      </Box>
    </Box>
  );
}


function SheetFilterItem({
  filter,
  filterIndex,
  editFilterComponents,
}) {
  const { sheetFilterValueChangeHandler, sheetFilterValues, clearFilter, applyFilter, clearFilterNotApplied } = useSheetFilterContext()
  const PopperTargetRef = useRef(null);
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [optionsState, setOptionsState] = useInitialOptionState(filter);
  const [searchOptionsState, debouncedFetchFilterOptions] = useSearchOptionsState({ filter, optionsState });
  const [inputValueFilter, setInputValueFilter] = useState(
    sheetFilterValues[filterIndex]?.[0]
  );
  const debouncedMultiSelectChangeHandler = useDebouncedFunction(
    (value) => {
      const values = sheetFilterValues[filterIndex]?.includes(value) ? sheetFilterValues[filterIndex]?.filter(val => val !== value) : [...sheetFilterValues[filterIndex] ?? [], value];
      sheetFilterValueChangeHandler({
        values,
        filterIndex
      })
    },
    100
  )

  const debouncedRadioSelectChangeHandler = useDebouncedFunction(
    (value) => {
      sheetFilterValueChangeHandler({
        values: [value],
        filterIndex
      })
    },
    100
  )

  const changeFilterInput = _.debounce(
    (e) => {
      setInputValueFilter(e.target.value);
      const filterValues = e.target.value
        ? e.target.value?.split("\n").filter((value) => value != "")
        : [];
      sheetFilterValueChangeHandler({
        values: filterValues,
        filterIndex,
        apply: true,
      });
    },
    1000
  );

  const getFilterLabel = () => {
    let { displayName, operator, displayNameOnSheet, member, listType } = filter
    let FilterLabel = displayNameOnSheet || displayName || member?.split('.')[1]

    if (listType === 'inputValue') {
      return `${FilterLabel} ${NUMBER_FILTER_TYPE[operator]}`;
    }
    return `${FilterLabel}${sheetFilterValues[filterIndex]?.length > 1 ? ` (${sheetFilterValues[filterIndex]?.length})` : ''}`;
  }

  async function clearAllFilter() {
    clearFilter({ filterIndex });
    setIsPopperOpen(false);

  }

  async function _applyFilter() {
    applyFilter({ filterIndex })
    setIsPopperOpen(false);
  }


  function selectAllOptions() {

    const values =
      sheetFilterValues[filterIndex]?.length === (searchOptionsState.options.length || optionsState.options.length)
        ? []
        : (
          searchOptionsState.options.length
            ? searchOptionsState.options.map(option => option)
            : optionsState.options.map(option => option)
        );
    sheetFilterValueChangeHandler({
      values,
      filterIndex
    })
  }

  const onModalClose = () => {
    setIsPopperOpen(false);
    clearFilterNotApplied({ filterIndex });
  }

  function FilterItem({ index, style, data }) {
    let label = data[index];
    let value = data[index];

    if (filter?.dynamicLabel) {
      const item = data[index];
      label = item[filter?.dynamicLabel?.label]
      value = item[filter?.member]
    }

    if (filter.listType === 'dropdown') {
      return (
        <div onClick={() => debouncedRadioSelectChangeHandler(value)} style={style} key={index}>
          <FormControlLabel
            className="text-small menu-item flex"
            value={value}
            control={<Radio className="form_icon" size='small' checked={sheetFilterValues[filterIndex]?.includes(value)} />}
            label={label}
          />
        </div>
      )
    }
    return (
      <>
        <div style={style} key={index}
          onClick={() => debouncedMultiSelectChangeHandler(value)}
        >
          <div
            title={label}
            className={"filters-dropdown-menuitem"}
            sx={{
              fontSize: '14px',
              color: '#202124',
              '&:hover': {
                backgroundColor: 'transparent'
              }
            }}
          >
            <FormControlLabel
              className="filters-view-checkbox"
              control={
                <Checkbox
                  className="form_checkbox"
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxCheckedIcon />}
                  checked={sheetFilterValues[filterIndex]?.includes(value)}
                />
              }
              label={label}
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <Box className={`dashboard-filters-view-item filter-enabled`} >
      {editFilterComponents && editFilterComponents[filter.filterIndex] ? editFilterComponents[filter.filterIndex] : null}
      <Box>
        <FormControl className="" variant="outlined" sx={{ width: '100%' }} size="small" >
          <Grid container mt={0}>
            <Grid item>
              {
                filter.listType === 'inputValue'
                  ? (
                    <Controls.Input autoComplete='off' type='number' className="report_form_ui_input" placeholder={getFilterLabel()} defaultValue={inputValueFilter} onChange={changeFilterInput}  multiline size="small"/>
                  ) : null
              }
              {
                (filter.operator === 'equals' || filter.operator === 'contains') && filter.listType !== 'inputValue'
                  ? (
                    <>
                      <Box sx={{ userSelect: 'none' }} className={`select_filters_input ` + (sheetFilterValues[filterIndex]?.length ? `has-value` : ``)}
                        id={`target-${filter.member}`} ref={PopperTargetRef} onClick={() => setIsPopperOpen(isOpen => !isOpen)} >
                        <Box className="select_filters_input_item dashboard-filters-input" display="flex" alignItems="center">
                          <Typography
                            variant="body2"
                            className="form_multi_input"
                          >
                            {sheetFilterValues[filterIndex]?.length === 1 
                              ? sheetFilterValues[filterIndex]?.[0] ? CamelToNormalString(sheetFilterValues[filterIndex]?.[0]) : 'Select' 
                              : getFilterLabel() ? CamelToNormalString(getFilterLabel()) : 'Select'
                            }
                          </Typography>
                        </Box>
                        <Box
                          className="select_filters_input_item filters-dropdown-icon"
                        >
                          {/* {sheetFilterValues[filterIndex]?.length ? <AngleDownIconWhite /> : <AngleDownIcon />} */}
                          {sheetFilterValues[filterIndex]?.length ? <AngleDownBlackIcon /> : <AngleDownIcon />}
                        </Box>
                      </Box>
                      {
                        isPopperOpen
                          ? (
                            <ClickAwayListener onClickAway={onModalClose}>
                              <Popper
                                id={`target-${filter.member}`}
                                open={isPopperOpen}
                                anchorEl={PopperTargetRef.current}
                                onClose={onModalClose}
                                placement="bottom-start"
                                disablePortal={false}
                                sx={{ zIndex: 10 }}
                              >
                                <Box className="filter-item-options dashboard-filters-view-popover quick-filter-popover 111">
                                  <Box className="filters-dropdown-item quick-filter-dd 222" sx={{ width: '100%' }}>
                                    {searchOptionsState.loading || optionsState.loading ? <Loader /> : null}
                                    <Box className="filters-dropdown-item-content">
                                      <TextField className=" cm_rprt_setting_content form_input_outline dasboard-filters-view-dropdown-search" type="search" size="medium" placeholder="Search..."
                                        onChange={debouncedFetchFilterOptions}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <InputSearchIcon className="input_search_icon" />
                                            </InputAdornment>
                                          ),
                                        }} />
                                      <div className="controlled-radio-buttons-group">
                                        {
                                          filter.listType === "dropdown" && (searchOptionsState.options.length || optionsState.options?.length)
                                            ? (
                                              <FormControlLabel
                                                onClick={clearAllFilter}
                                                className="text-small menu-item flex quick-filter-option-none"
                                                value={''}
                                                control={<Radio className="form_icon" size='small' />}
                                                label={'None'}
                                              />
                                            )
                                            : null
                                        }

                                        {
                                          filter.listType !== "dropdown" && (searchOptionsState.options.length || optionsState.options.length)
                                            ? (
                                              <Box className='filters-view-checbox-toggle' >
                                                <Box className='filter-selectall-option'>
                                                  <div
                                                    title={"Select All"}
                                                    className={"filters-dropdown-menuitem select-all-option"}
                                                    sx={{
                                                      fontSize: '14px',
                                                      color: '#202124',
                                                      '&:hover': {
                                                        backgroundColor: 'transparent'
                                                      }
                                                    }}
                                                  >
                                                    <FormControlLabel
                                                      className="filters-view-checkbox"
                                                      control={
                                                        <Checkbox
                                                          className="form_checkbox"
                                                          icon={<CheckBoxIcon />}
                                                          checkedIcon={<CheckBoxCheckedIcon />}
                                                          checked={sheetFilterValues[filterIndex]?.length === (searchOptionsState.options.length || optionsState.options.length)}
                                                          onClick={selectAllOptions}
                                                        />
                                                      }
                                                      label={"Select All"}
                                                    />
                                                  </div>
                                                </Box>
                                              </Box>

                                            ) : null
                                        }

                                        <div className={`virtual-filter-div ` + ((searchOptionsState.options.length || optionsState.options.length) ? 'filter-data-exists ' : ` `)
                                          + (((searchOptionsState.options.length || optionsState.options.length) && optionsState.options.length < 5) ? ` filter-data-auto ${NUMBER_VALUES[optionsState.options.length - 1]}` : ` `)}>
                                          <AutoSizer>
                                            {({ height, width }) => (
                                              <List
                                                className="List"
                                                height={searchOptionsState.options.length || optionsState.options.length ? height : 20}
                                                itemCount={searchOptionsState.options.length ? searchOptionsState.options.length : optionsState.options.length}
                                                width={width - 4}
                                                itemData={searchOptionsState.options.length ? searchOptionsState.options : optionsState.options}
                                                itemSize={42}
                                              >
                                                {FilterItem}
                                              </List>
                                            )}
                                          </AutoSizer>
                                        </div>
                                        <Box className="filters-dropdown-item-footer test">
                                          <Button
                                            className="report_form_ui_btn cancel cancel2"
                                            disabled={sheetFilterValues[filterIndex]?.length === 0}
                                            onClick={clearAllFilter}
                                            style={{ fontWeight: 'normal' }}
                                          >
                                            Clear All
                                          </Button>

                                          <Button
                                            className="report_form_ui_btn submit submit2"
                                            variant="contained"
                                            onClick={_applyFilter}
                                          >
                                            Apply
                                          </Button>
                                        </Box>
                                      </div>
                                    </Box>
                                  </Box>
                                </Box>
                              </Popper>
                            </ClickAwayListener>
                          )
                          : null
                      }
                    </>
                  ) : null
              }
              {
                (filter.operator === 'inDateRange' || filter.operator === 'notInDateRange') && filter.listType !== 'inputValue'
                  ? (
                    <DateRangeFilter
                      filter={filter}
                      filterIndex={filterIndex}
                      setIsPopperOpen={setIsPopperOpen}
                    />
                  ) : null
              }
            </Grid>
          </Grid>
        </FormControl>
      </Box>
    </Box>
  )
}

function DateRangeFilter({ filter, filterIndex, setCurrentTab }) {
  const { sheetFilterValues, clearFilter, applyFilter, sheetFilterValueChangeHandler: updateFilter, clearFilterNotApplied } = useSheetFilterContext();
  // const filterValues = structuredClone(filter.values.le || sheetFilterValues[filter.filterIndex] || []);
  const filterValues = useMemo(() => {
    //console.log('Value Change',sheetFilterValues[filter.filterIndex],filter.values)
    const values = sheetFilterValues[filter.filterIndex];
    if (values.length < 0 && filter.values.length > 0 && filter.values[0] && filter.values[1] && filter?.dateFilterProps?.selectedTimePeriod === 'Custom') return filter.values;
    
    if (values.length > 0 && (values[0] || values[1])) return values;
    return []
  }, [sheetFilterValues[filter.filterIndex]]);
  const [timePeriodValue, setTimePeriodValue] = useState(null);
  const filterRef = useRef(null);
  const [filterInputOpen, setFilterInputOpen] = useState(false);

  const setInitialTimePeriodValue = () => {
    setTimePeriodValue(filter?.dateFilterProps?.selectedTimePeriod ?? null);
  }

  useEffect(() => {
    if (!timePeriodValue || filter.dateFilterProps?.selectedTimePeriod !== timePeriodValue)
      setInitialTimePeriodValue();
  }, [filter?.dateFilterProps?.selectedTimePeriod])

  const onDateRangeChange = ({ startDate, endDate }) => {
    //console.log(filterValues)
    const values = filterValues ?? [];
    const timeFlag = filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime" ? true:false
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format('YYYY/MM/DD HH:mm:ss');
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      values[1] = endDate && !timeFlag ? moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'): moment(endDate).format('YYYY/MM/DD HH:mm:ss')
    }
    updateFilter({ filterIndex: filter.filterIndex, values })
  }

  function onTimePeriodChange(event) {
    //console.log(filter)
    if (event.target.value === 'Custom') {
      //console.log(filter)
      setTimePeriodValue(event.target.value);
      updateFilter({
        filterIndex: filter.filterIndex,
        values: filter?.dateFilterProps?.selectedTimePeriod === 'Custom' && filter?.values.length > 0 ? filter?.values : [],
        // values: [],
      })
      return
    }
    setTimePeriodValue(event.target.value);
    const { startDate, endDate } = generateCustomDateRange(event.target.value)
    updateFilter({
      filterIndex: filter.filterIndex,
      values: [startDate, endDate],
    })
  }

  function onCustomTimePeriodChange({ startDate, endDate }) {
    //console.log(filterValues)
    const values = structuredClone(filterValues ?? []);
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format('YYYY/MM/DD HH:mm:ss');
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      let date = moment(endDate);
      if (date.hour() !== 23) {
        date = date.hour(23).minute(59).second(59);
      }
      values[1] = date.format('YYYY/MM/DD HH:mm:ss');
    }
    // filter.values = values;
    updateFilter({ filterIndex, values })
  }

  async function onClearFilter() {
    setTimePeriodValue('')
    clearFilter({ filterIndex, filterMetaData: { dateFilterProps: { ...filter.dateFilterProps, selectedTimePeriod: '' } } })
    // clearFilterNotApplied({ filterIndex })
    setFilterInputOpen(false);
  }

  const onApplyFilter = () => {
    applyFilter({
      filterIndex,
      filterMetaData: {
        dateFilterProps: {
          ...filter.dateFilterProps,
          selectedTimePeriod: timePeriodValue
        }
      },
    });
    setFilterInputOpen(false);
  }

  const handleModalClose = () => {
    setFilterInputOpen(false);
    if (filter.dateFilterProps?.dateSelectType === "TIME_PERIOD") {
      setInitialTimePeriodValue()
      if (filter.values?.length === 0 && filterValues.length !== 0) {
        clearFilterNotApplied({ filterIndex })
      }
    } else {
      clearFilterNotApplied({ filterIndex })
    }
  }

  const filterLabel = useMemo(() => {
    let label = 'Select';
    if (filter.dateFilterProps?.dateSelectType === "TIME_PERIOD") {
      label = 'Time Period'
      if (timePeriodValue === 'Custom') {
        if (filterValues?.[0]) label = `${moment(filterValues?.[0])?.format('DD/MM/yyyy')}`;
        if (filterValues?.[1]) label = `${label} - ${moment(filterValues?.[1])?.format('DD/MM/yyyy')}`;
      } else {
        if (timePeriodValue?.length) label = timePeriodValue
      }
    } else {
      label = 'Date Range'
      if (filterValues?.[0]) label = `${moment(filterValues?.[0])?.format('DD/MM/yyyy')}`;
      if (filterValues?.[1]) label = `${label} - ${moment(filterValues?.[1])?.format('DD/MM/yyyy')}`;
    }
    return label === '' ? 'Select' : label;
  }, [filter, filterValues?.[0], filterValues?.[1], timePeriodValue])

  return (
    <>
      <Box
        className={`select_filters_input quick-filter-item ` + (false ? ` has-value` : ``)}
        onClick={() => setFilterInputOpen(isOpen => !isOpen)}
        ref={filterRef}
      >
        <Box className="select_filters_input_item" display="flex" alignItems="center">
          <Typography className={"label-font "}> {filterLabel || 'Select'} </Typography>
        </Box>
        <Box className="select_filters_input_item select_filters_input_item_icon "><CalendarIcon className="cr-form-date-icon" /></Box>
      </Box>
      {
        filterInputOpen
          ? (
            <ClickAwayListener onClickAway={handleModalClose}>
              <Popper
                id={`target-${filter.member}`}
                open={filterInputOpen}
                anchorEl={filterRef.current}
                onClose={handleModalClose}
                placement="bottom-start"
                disablePortal={false}
                style={{ zIndex: 10 }}
              >
                <Box className="filter-item-options dashboard-filters-view-popover quick-filter-popover">
                  <Box className="filters-dropdown-item quick-filter-dd 222" sx={{ width: '100%' }}>
                    {
                      filter.dateFilterProps?.dateSelectType === "DATE_RANGE"
                        ? (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              height: '100%',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexGrow: 1,
                              }}
                            >
                              <Grid sx={{ height: 'fit-content', padding: '20px 20px 12px' }} container spacing={2} >
                                <Grid xs={12} md={6} item >
                                  <Typography className="report-form-label text-small" variant="subtitle2" >Start Date</Typography>
                                  <DatePicker
                                    autoComplete='off'
                                    dropdownMode="select"
                                    showYearDropdown={true}
                                    showMonthDropdown={true}
                                    dateFormat="dd/MM/yyyy"
                                    className="report_form_ui_input_date width-150px"
                                    minDate={new Date("01-01-2021 00:00:00")}
                                    maxDate={new Date()}
                                    selected={filterValues[0] && moment(filterValues[0]).toDate()}
                                    showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                                    onChange={(date) => onDateRangeChange({ startDate: date })}
                                    customInput={
                                      <TextField className={`report_form_ui_input_date er-input-filter width-150px ${filterValues[0] ? `has-value` : ``}`}
                                        autoComplete='off'
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <CalendarIcon />
                                            </InputAdornment>
                                          ),
                                        }} />
                                    }
                                    popperModifiers={[
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, 5],
                                        },
                                      },
                                      {
                                        name: "preventOverflow",
                                        options: {
                                          rootBoundary: "viewport",
                                          tether: false,
                                          altAxis: true,
                                        },
                                      },
                                    ]}
                                  />
                                </Grid>
                                <Grid xs={12} md={6} item >
                                  <Typography className="report-form-label text-small" variant="subtitle2" >End Date</Typography>
                                  <DatePicker
                                    autoComplete='off'
                                    maxDate={new Date()}
                                    dropdownMode="select"
                                    showYearDropdown={true}
                                    showMonthDropdown={true}
                                    dateFormat="dd/MM/yyyy"
                                    className="report_form_ui_input_date "
                                    minDate={new Date(filterValues[0])}
                                    selected={filterValues[1] && moment(filterValues[1]).toDate()}
                                    onChange={(date) => onDateRangeChange({ endDate: date })}
                                    showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                                    customInput={
                                      <TextField className={`report_form_ui_input_date er-input-filter width-150px ${filterValues[1] ? `has-value` : ``}`}
                                        autoComplete='off'
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <CalendarIcon />
                                            </InputAdornment>
                                          ),
                                        }} />
                                    }
                                    popperModifiers={[
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, 5],
                                        },
                                      },
                                      {
                                        name: "preventOverflow",
                                        options: {
                                          rootBoundary: "viewport",
                                          tether: false,
                                          altAxis: true,
                                        },
                                      },
                                    ]}
                                  />
                                </Grid>
                              </Grid>
                            </Box>
                            <Box className="filters-dropdown-item-footer test">
                              <Button
                                className="report_form_ui_btn cancel cancel2"
                                disabled={!Boolean(filterValues[0]) && !Boolean(filterValues[1])}
                                onClick={onClearFilter}
                                style={{ fontWeight: 'normal' }}
                              >
                                Clear All
                              </Button>

                              <Button
                                className="report_form_ui_btn submit submit2"
                                variant="contained"
                                onClick={onApplyFilter}
                              >
                                Apply
                              </Button>
                            </Box>
                          </Box>
                        )
                        : (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              height: '100%',
                              width: '100%',
                              padding: '10px 0 0',
                            }}
                          >
                            <Box sx={{ display: 'flex', flexGrow: '1', paddingX: '5px', overflow: 'visible', zIndex: '9999', maxHeight: 'calc(100% - 60px)' }}>
                              <Grid className='filters-datefilter-group' sx={{ height: '100%', overflow: 'visible', width: '100%' }}>
                                <RadioGroup
                                  name="controlled-radio-buttons-group"
                                >
                                  {
                                    filter.dateFilterProps?.timePeriod?.map((timePeriod, index) => {
                                      return (
                                        <FormControlLabel
                                          key={`time-period-radio${index}`}
                                          title={timePeriod}
                                          className="text-plain menu-item"
                                          label={timePeriod}
                                          sx={{ paddingX: '7px', marginX: 0 }}
                                          control={
                                            <Radio
                                              className="form_checkbox"
                                              size="small"
                                              checked={timePeriodValue === timePeriod}
                                              value={timePeriod}
                                              onChange={onTimePeriodChange}
                                            />
                                          }
                                        />
                                      )
                                    })
                                  }
                                  {
                                    filter.dateFilterProps && timePeriodValue === 'Custom' ? (
                                      <Box className="filters-dropdown-item-content" sx={{ p: '0.5rem 14px !important' }}>
                                        <Grid container spacing={2} >
                                          <Grid xs={12} md={6} item >
                                            <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>
                                            <DatePicker
                                              autoComplete='off'
                                              maxDate={new Date()}
                                              dropdownMode="select"
                                              dateFormat="dd/MM/yyyy"
                                              showYearDropdown={true}
                                              showMonthDropdown={true}
                                              minDate={new Date("01-01-2021 00:00:00")}
                                              className="report_form_ui_input_date er-input-filter width-150px"
                                              onChange={(date) => onCustomTimePeriodChange({ startDate: date })}
                                              selected={filterValues[0] && moment(filterValues[0]).toDate()}
                                              customInput={
                                                <TextField className={`report_form_ui_input_date er-input-filter ${filterValues[0] ? `has-value` : ``}`}
                                                  autoComplete='off'
                                                  InputProps={{
                                                    endAdornment: (
                                                      <InputAdornment position="start">
                                                        <CalendarIcon />
                                                      </InputAdornment>
                                                    ),
                                                  }} />
                                              }
                                              popperModifiers={[
                                                {
                                                  name: "offset",
                                                  options: {
                                                    offset: [0, 5],
                                                  },
                                                },
                                                {
                                                  name: "preventOverflow",
                                                  options: {
                                                    rootBoundary: "viewport",
                                                    tether: false,
                                                    altAxis: true,
                                                  },
                                                },
                                              ]}
                                            />
                                          </Grid>
                                          <Grid xs={12} md={6} item >
                                            <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>
                                            <DatePicker
                                              autoComplete='off'
                                              dropdownMode="select"
                                              maxDate={new Date()}
                                              dateFormat="dd/MM/yyyy"
                                              showYearDropdown={true}
                                              showMonthDropdown={true}
                                              minDate={new Date(filterValues[0])}
                                              className="report_form_ui_input_date er-input-filter width-150px"
                                              selected={filterValues[1] && moment(filterValues[1]).toDate()}
                                              onChange={(date) => onCustomTimePeriodChange({ endDate: date })}
                                              showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                                              customInput={
                                                <TextField className={`report_form_ui_input_date er-input-filter ` + (filterValues[1] ? `has-value` : ``)}
                                                  autoComplete='off'
                                                  InputProps={{
                                                    endAdornment: (
                                                      <InputAdornment position="start">
                                                        <CalendarIcon />
                                                      </InputAdornment>
                                                    ),
                                                  }} />
                                              }
                                              popperModifiers={[
                                                {
                                                  name: "offset",
                                                  options: {
                                                    offset: [0, 5],
                                                  },
                                                },
                                                {
                                                  name: "preventOverflow",
                                                  options: {
                                                    rootBoundary: "viewport",
                                                    tether: false,
                                                    altAxis: true,
                                                  },
                                                },
                                              ]}
                                            />
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    ) : null
                                  }
                                </RadioGroup>
                              </Grid>
                            </Box>
                            <Box className="filters-dropdown-item-footer test">
                              <Button
                                className="report_form_ui_btn cancel cancel2"
                                disabled={!timePeriodValue}
                                onClick={onClearFilter}
                                style={{ fontWeight: 'normal' }}
                              >
                                Clear All
                              </Button>

                              <Button
                                className="report_form_ui_btn submit submit2"
                                variant="contained"
                                onClick={onApplyFilter}
                              >
                                Apply
                              </Button>
                            </Box>
                          </Box>
                        )
                    }
                  </Box>
                </Box>

              </Popper >
            </ClickAwayListener >
          )
          : null
      }
    </>
  )
}

function MobileViewSheetFilter({
  editFilterComponents
}) {
  const { sheetFilters } = useSheetFilterContext();
  const [currentTab, setCurrentTab] = useState(null);
  useEffect(() => {
    if (!sheetFilters || sheetFilters?.length === 0 || currentTab !== null) return;
    const filterIndex = sheetFilters?.find((filter) => filter?.isCascadedHidden === false)?.filterIndex
    if ((filterIndex !== null || filterIndex !== undefined) && currentTab !== filterIndex) {
      setCurrentTab(filterIndex !== null || filterIndex !== undefined ? filterIndex : null)
    }
  }, [sheetFilters])

  const [filtersModalMobileStatus, setFiltersModalMobileStatus] = useState(false);
  useEffect(() => {
    if (filtersModalMobileStatus) {
      document.body.classList.add("modal-viewport-mobile");
    } else {
      document.body.classList.remove("modal-viewport-mobile");
    }
  }, [filtersModalMobileStatus]);

  if (!sheetFilters.filter(filter => !filter.hidden)?.length) return null;

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleCloseFilterModal = () => {
    setFiltersModalMobileStatus(false);
  }


  return (
    <>
      <Box sx={{ flexGrow: 1 }} key={`sheetfilter`}>
        <Box className={`dashboard-view-filters-container`}>
          <Controls.Button track-this="Filters" tracked-type="button" name=""
            className="filters-view-btn" text="Filters" variant="outline"
            startIcon={<FilterIcon className="btn_icon_before" />} onClick={() => setFiltersModalMobileStatus(true)} />
          <Modal
            aria-labelledby="transition-modal-viewport"
            aria-describedby="transition-modal-viewport"
            className="modal-root modal-viewport-root"
            open={filtersModalMobileStatus}
            onClose={handleCloseFilterModal}
            closeAfterTransition
          >
            <Fade in={filtersModalMobileStatus}>
              <Box className="modal-paper modal-viewport" id="transition-modal-viewport" 
                // style={{ height: 'calc(100% - 70px)' }} /* bug in mobile filters - when teacher app header is changed */
              >
                <CloseIcon onClick={handleCloseFilterModal} className="enlarge-close" />
                <Box className="modal-viewport-header" >
                  <Typography variant="subtitle1" className="modal-viewport-header-title" >{`Filter`}</Typography>
                </Box>
                <Box className="modal-viewport-content">
                  <Box className="modal-viewport-content-container" sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', }} >
                    {
                      sheetFilters?.length && sheetFilters?.filter(obj => !obj?.hidden)?.length ?
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              height: '100%',
                              overflow: 'auto',
                              minWidth: '135px',
                              backgroundColor: '#f1f1f1',
                            }}
                          >
                            {
                              sheetFilters.map((filter, index) => {
                                if (filter?.isCascadedHidden) return null;
                                const isSelected = currentTab === filter.filterIndex;
                                return (
                                  <Box
                                    key={`filter-item-tab-${filter.member}`}
                                    sx={{
                                      height: '48px',
                                      backgroundColor: isSelected ? '#fff' : '#f1f1f1',
                                      borderLeft: isSelected ? '3px solid #f45e29' : '3px solid #f1f1f1',
                                      color: isSelected ? '#f45e29' : '#202124',
                                      borderRight: 0,
                                      fontSize: '14px',
                                      fontWeight: isSelected ? 600 : 400,
                                      textAlign: 'left',
                                      padding: '0.7rem'
                                    }}
                                    onClick={() => handleTabChange(null, filter.filterIndex)}
                                  >
                                    {filter?.displayNameOnSheet || filter?.displayName || filter?.member?.split('.')[1]}
                                  </Box>
                                )
                              })
                            }
                          </Box>
                          {
                            sheetFilters?.map((filter, index) => {
                              if (filter?.isCascadedHidden || filter?.hidden) return null;
                              return (
                                <Box
                                  key={`filter-item-tab-panel-${filter.member}`}
                                  sx={{
                                    display: currentTab === index ? 'flex' : 'none',
                                    overflow: 'hidden',
                                    height: '100%',
                                    width: '100%',
                                  }}
                                >
                                  <MobileSheetFilterItem
                                    filter={filter}
                                    editFilterComponents={editFilterComponents}
                                    setFiltersModalMobileStatus={setFiltersModalMobileStatus}
                                  />
                                </Box>
                              )
                            })
                          }
                        </>
                        : null
                    }
                  </Box>
                </Box>
              </Box>
            </Fade>
          </Modal >
        </Box>
      </Box>
    </>
  )
}

function MobileSheetFilterItem({
  filter,
  setFiltersModalMobileStatus,
}) {
  const { filterIndex } = filter;
  const { sheetFilterValueChangeHandler, sheetFilterValues, clearFilter, applyFilter } = useSheetFilterContext()
  const [isFilterApplyLoading, setIsFilterApplyLoading] = useState(false);
  const filterValues = sheetFilterValues[filterIndex] ?? []
  const [optionsState] = useInitialOptionState(filter);
  const [searchOptionsState, debouncedFetchFilterOptions] = useSearchOptionsState({ filter, optionsState });

  const debouncedMultiSelectChangeHandler = useDebouncedFunction(
    (value) => {
      const filterValues = sheetFilterValues[filterIndex]?.includes(value)
        ? sheetFilterValues[filterIndex]?.filter(val => val !== value)
        : [...sheetFilterValues[filterIndex] ?? [], value];
      sheetFilterValueChangeHandler({
        values: filterValues,
        filterIndex
      })
    },
    100
  )

  const debouncedRadioSelectChangeHandler = useDebouncedFunction(
    (value) => {
      sheetFilterValueChangeHandler({
        values: [value],
        filterIndex
      })
    },
    100
  )

  const { currentSheet } = useDashboardContext();

  async function clearAllFilter() {
    // clear filter if applied
    // console.log('clearAllFilter', sheetFilterValues[filterIndex])
    if (sheetFilterValues[filterIndex]?.length) {
      // if (currentSheet.sheetFilter[filterIndex].values.length === 0) {
      //   // setFiltersModalMobileStatus(false);
      //   setFilterValues([]);
      //   return
      // }
      // const _filter = structuredClone(filter);
      // _filter.values = [];
      // delete _filter['filterIndex'];
      // delete _filter['isCascadedHidden']
      // if (filter?.operator === 'inDateRange' || filter?.operator === 'notInDateRange') {
      //   if (filter?.dateFilterProps?.selectedTimePeriod) {
      //     _filter.dateFilterProps.selectedTimePeriod = ''
      //   }
      // }
      // await applyFiltersOnCurrentSheet({ sheetFilter: _filter, filterIndex });
      // setFiltersModalMobileStatus(false);
      clearFilter({ filterIndex });
      return
    }
  }

  async function onApplyFilter({ sheetFilter }) {
    applyFilter({ filterIndex });
  }

  function selectAllOptions() {
    let _filterValues = sheetFilterValues[filterIndex].length === (searchOptionsState.options.length || optionsState.options.length)
      ? []
      : (
        searchOptionsState.options.length
          ? searchOptionsState.options.map(option => option)
          : optionsState.options.map(option => option)
      );
    //console.log('select all option in mob', { _filterValues })
    sheetFilterValueChangeHandler({
      values: _filterValues,
      filterIndex
    })
  }

  function FilterItem({ index, style, data }) {
    let label = data[index];
    let value = data[index];

    if (filter?.dynamicLabel) {
      const item = data[index];
      label = item[filter?.dynamicLabel?.label]
      value = item[filter?.member]
    }

    if (filter.listType === 'dropdown') {
      return (
        <div onClick={() => debouncedRadioSelectChangeHandler(value)} style={style} key={`filter-option-${index}-${label}`}>
          <FormControlLabel
            className="text-small menu-item flex"
            value={value}
            control={<Radio className="form_icon" size='small' checked={sheetFilterValues[filterIndex]?.includes(value)} />}
            label={label}
          />
        </div>
      )
    }
    return (
      <>
        <div style={style} key={`filter-option-${index}`}
          onClick={() => debouncedMultiSelectChangeHandler(value)}
        >
          <div
            title={label}
            className={"filters-dropdown-menuitem"}
            sx={{
              fontSize: '14px',
              color: '#202124',
              '&:hover': {
                backgroundColor: 'transparent'
              }
            }}
          >
            <FormControlLabel
              className="filters-view-checkbox"
              control={
                <Checkbox
                  className="form_checkbox"
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxCheckedIcon />}
                  checked={sheetFilterValues[filterIndex]?.includes(value)}
                // checked={filter.values.includes(value)}
                // checked={filter.values.includes(value)}
                />
              }
              label={label}
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <Box
      sx={{ p: '0.25rem 0 0.25rem 1rem', width: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}
      className={`report-chart-filters-list quick-filter-dd-m ` + isFilterApplyLoading}
    >
      {
        (filter.operator === "equals")
          ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
              }}
            >

              <TextField
                type="search"
                size="medium"
                placeholder="Search..."
                className="dasboard-filters-view-dropdown-search width-90p mt-8p"
                onChange={debouncedFetchFilterOptions}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <InputSearchIcon className="input_search_icon" />
                    </InputAdornment>
                  ),
                }}
              />

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {
                  (filter.listType !== 'dropdown')
                    ? (
                      <Box
                        className={"filters-dropdown-menuitem select-all-option"}
                        sx={{
                          fontSize: '14px',
                          color: '#202124',
                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          marginY: '0.5rem'
                        }}
                      >
                        <FormControlLabel
                          className="filters-view-checkbox"
                          onChange={selectAllOptions}
                          control={
                            <Checkbox
                              className="form_checkbox"
                              icon={<CheckBoxIcon />}
                              checkedIcon={<CheckBoxCheckedIcon />}
                              checked={!searchOptionsState.loading && searchOptionsState.options.length ? searchOptionsState.options.length === filterValues.length : !optionsState.loading && optionsState.options.length ? optionsState.options.length === filterValues.length : false}
                            />
                          }
                          label={'Select All'}
                        />
                      </Box>
                    )
                    : null
                }
                <div
                  className={`virtual-filter-div ` + ((searchOptionsState.options.length || optionsState.options.length) ? 'filter-data-exists ' : ` `)
                    + (((searchOptionsState.options.length || optionsState.options.length) && optionsState.options.length < 5) ? ` filter-data-auto ${NUMBER_VALUES[optionsState.options.length - 1]}` : ` `)}
                >
                  <AutoSizer>
                    {({ height, width }) => (
                      <List
                        itemSize={42}
                        className="List"
                        width={width - 4}
                        height={searchOptionsState.options.length || optionsState.options.length ? height : 20}
                        itemData={searchOptionsState.options.length ? searchOptionsState.options : optionsState.options}
                        itemCount={searchOptionsState.options.length ? searchOptionsState.options.length : optionsState.options.length}
                      >
                        {FilterItem}
                      </List>
                    )}
                  </AutoSizer>
                </div>
              </Box>
              <Box className='report-mobile-filters-actions filters-popover-footer'>
                <Box className='report-mobile-filters-actions-wrapper'>
                  <Controls.Button className="report_form_ui_btn cancel cancel2" color="secondary" text="Clear All" onClick={clearAllFilter} />
                  <Controls.Button className="report_form_ui_btn submit submit2" type="submit" text="Apply" onClick={onApplyFilter} />
                </Box>
              </Box>
            </Box>
          )
          : (
            <Box className='mt-8p width-90p'>
              <DateRange
                filter={filter}
                applyFilter={onApplyFilter}
                clearFilter={() => clearFilter({ filterIndex, filterMetaData: { dateFilterProps: { ...filter.dateFilterProps, selectedTimePeriod: '' } } })}
                updateFilter={sheetFilterValueChangeHandler}
                sheetFilterValues={sheetFilterValues}
              />
            </Box>
          )
      }
    </Box>
  )
}

function DateRange({ filter, clearFilter, applyFilter, updateFilter, sheetFilterValues }) {
  const filterValues = sheetFilterValues[filter.filterIndex] ?? [];
  //console.log(filterValues)
  const [timePeriodValue, setTimePeriodValue] = useState(filter.dateFilterProps?.selectedTimePeriod ?? '');
  function onDateRangeChange({ startDate, endDate }) {
    const values = filterValues;
    const timeFlag = filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime" ? true:false
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format("YYYY/MM/DD HH:mm:ss");
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      values[1] = endDate && !timeFlag ? moment(endDate).endOf('day').format("YYYY/MM/DD HH:mm:ss") : moment(endDate).format("YYYY/MM/DD HH:mm:ss");
    }
    // filter.values = values;
    updateFilter({ filterIndex: filter.filterIndex, values })
  }
  if (filter.dateFilterProps?.dateSelectType === "DATE_RANGE") {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
          }}
        >
          <Grid sx={{ height: 'fit-content' }} container spacing={2} >
            <Grid xs={10} md={10} item >
              <Typography className="report-form-label text-small" variant="subtitle2" >Start Date</Typography>
              <DatePicker
                autoComplete='off'
                dropdownMode="select"
                showYearDropdown={true}
                showMonthDropdown={true}
                dateFormat="dd/MM/yyyy"
                className="report_form_ui_input_date"
                minDate={new Date("01-01-2021 00:00:00")}
                maxDate={new Date()}
                selected={filterValues[0] && moment(filterValues[0]).toDate()}
                showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                onChange={(date) => onDateRangeChange({ startDate: date })}
                customInput={
                  <TextField className={`report_form_ui_input_date er-input-filter ` + (filterValues[0] ? `has-value` : ``)}
                    autoComplete='off'
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon />
                        </InputAdornment>
                      ),
                    }} />
                }
              />
            </Grid>
            <Grid xs={10} md={10} item >
              <Typography className="report-form-label text-small" variant="subtitle2" >End Date</Typography>
              <DatePicker
                autoComplete='off'
                maxDate={new Date()}
                dropdownMode="select"
                showYearDropdown={true}
                showMonthDropdown={true}
                dateFormat="dd/MM/yyyy"
                className="report_form_ui_input_date"
                minDate={new Date(filterValues[0])}
                selected={filterValues[1] && moment(filterValues[1]).toDate()}
                onChange={(date) => onDateRangeChange({ endDate: date })}
                showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                customInput={
                  <TextField className={`report_form_ui_input_date er-input-filter ` + (filterValues[1] ? `has-value` : ``)}
                    autoComplete='off'
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon />
                        </InputAdornment>
                      ),
                    }} />
                }
              />
            </Grid>
          </Grid>
        </Box>
        <Box className='report-mobile-filters-actions filters-popover-footer'>
          <Box className='report-mobile-filters-actions-wrapper'>
            <Controls.Button className="report_form_ui_btn cancel cancel2" color="secondary" text="Clear All" onClick={onClearFilter} />
            <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" onClick={() => applyFilter(filter.filterIndex)} />
          </Box>
        </Box>
      </Box>
    )
  }
  async function onTimePeriodChange(event) {
    //console.log(filterValues)
    if (event.target.value === 'Custom') {
      setTimePeriodValue(event.target.value);
      // filter.values = [];
      // filter.dateFilterProps.selectedTimePeriod = event.target.value;
      // await clearFilter();
      await updateFilter({ filterIndex: filter.filterIndex, values: [], filterMetaData: { dateFilterProps: { ...filter.dateFilterProps, selectedTimePeriod: event.target.value } } })
      return
    }
    const { startDate, endDate } = generateCustomDateRange(event.target.value)
    // filter.values = [startDate, endDate];
    // filter.dateFilterProps.selectedTimePeriod = event.target.value;
    updateFilter({ filterIndex: filter.filterIndex, values: [startDate, endDate], filterMetaData: { dateFilterProps: { ...filter.dateFilterProps, selectedTimePeriod: event.target.value } } })
  }

  function onCustomTimePeriodChange({ startDate, endDate }) {
    const values = filterValues;
    //console.log(filterValues)
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format("YYYY/MM/DD HH:mm:ss");
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      const date = moment(endDate);
      if (date.hour() !== 23) {
        date.hour(23).minute(59).second(59)
      }
      values[1] = date.format("YYYY/MM/DD HH:mm:ss")
    }
    // filter.values = values;
    updateFilter({ filterIndex: filter.filterIndex, values })
  }

  function onClearFilter() {
    setTimePeriodValue('')
    clearFilter(filter.filterIndex)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexGrow: '1', overflow: 'auto' }}>
        <Grid className='filters-datefilter-group' >
          <RadioGroup
            name="controlled-radio-buttons-group"
          >
            {
              filter.dateFilterProps?.timePeriod?.map((timePeriod, index) => {
                return (
                  <FormControlLabel
                    key={`time-period-radio${index}`}
                    title={timePeriod}
                    className="menu-item menu-item-light"
                    label={timePeriod}
                    sx={{ paddingLeft: '10px !important' }}
                    control={
                      <Radio
                        className="form_checkbox"
                        size="small"
                        checked={filter.dateFilterProps?.selectedTimePeriod === timePeriod}
                        value={timePeriod}
                        onChange={onTimePeriodChange}
                      />
                    }
                  />
                )
              })
            }
            { 
              filter.dateFilterProps && timePeriodValue === 'Custom' ? (
                <Box className="filters-dropdown-item-content" sx={{ p: '0.5rem 0 !important' }}>
                  <Grid container >
                    <Grid xs={12} md={12} item sx={{ marginBottom: '10px' }} >
                      <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>
                      <DatePicker
                        autoComplete='off'
                        maxDate={new Date()}
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        minDate={new Date("01-01-2021 00:00:00")}
                        className="report_form_ui_input_date er-input-filter width-150px"
                        onChange={(date) => onCustomTimePeriodChange({ startDate: date })}
                        selected={filterValues?.[0] && moment(filterValues?.[0]).toDate()}
                        customInput={
                          <TextField className={`report_form_ui_input_date er-input-filter ${filterValues[0] ? `has-value` : ``}`}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <CalendarIcon />
                                </InputAdornment>
                              ),
                            }} />
                        }
                      />
                    </Grid>
                    <Grid xs={12} md={12} item >
                      <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>
                      <DatePicker
                        autoComplete='off'
                        dropdownMode="select"
                        maxDate={new Date()}
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        minDate={new Date(filterValues[0])}
                        className="report_form_ui_input_date er-input-filter width-150px"
                        selected={filterValues[1] && moment(filterValues[1]).toDate()}
                        onChange={(date) => onCustomTimePeriodChange({ endDate: date })}
                        showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                        customInput={
                          <TextField className={`report_form_ui_input_date er-input-filter ` + (filterValues[1] ? `has-value` : ``)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <CalendarIcon />
                                </InputAdornment>
                              ),
                            }} />
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              ) : null
            }
          </RadioGroup>
        </Grid>
      </Box>
      <Box className='report-mobile-filters-actions filters-popover-footer'>
        <Box className='report-mobile-filters-actions-wrapper'>
          <Controls.Button className="report_form_ui_btn cancel cancel2" color="secondary" text="Clear All" onClick={onClearFilter} />
          <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" onClick={() => applyFilter(filter.filterIndex)} />
        </Box>
      </Box>
    </Box>
  )
}

function useInitialOptionState(filter) {
  const [optionsState, setOptionsState] = useState({
    options: [],
    loading: false,
    error: null
  });
  const { sheetFilters } = useSheetFilterContext();
  useEffect(() => {
    if (!filter?.isCascadedHidden && optionsState.options.length === 0) {
      fetchInitalOptionsFromCube()
    }
  }, [filter?.isCascadedHidden]); // depedenecy
  async function fetchInitalOptionsFromCube() {
    setOptionsState((state) => ({ ...state, loading: true }))
    try {
      // relevant values case handle
      if (filter.specificValue) {
        setOptionsState((state) => ({ ...state, options: filter.valuesList }))
        return
      }
      if (filter.member && filter.dataSetType) {
        let fetchedData = null
        let filters = sheetFilters?.filter(_filter => _filter?.member === filter?.relevantTo);
        filters = filters?.map(_filter => {
          return {
            member: _filter?.member,
            operator: 'equals',
            values: _filter?.values
          }
        });
        if (filter?.dynamicLabel) {
          fetchedData = await getDataFromCube(filter?.member, filter?.dataSetType, filters, "filterDynamicLabel", filter?.dynamicLabel);
        } else {
          fetchedData = await getDataFromCube(filter?.member, filter?.dataSetType, filters);
        }
        if (fetchedData !== null) {
          setOptionsState((state) => ({ ...state, options: fetchedData }));
        }
      }
    } catch (error) {
      setOptionsState((state) => ({ ...state, error: error.message }))
    } finally {
      setOptionsState((state) => ({ ...state, loading: false }))
    }
  }
  return [optionsState, setOptionsState];
}
function useSearchOptionsState({ filter, optionsState }) {
  const [searchOptionsState, setSearchOptionsState] = useState({
    options: [],
    loading: false,
    error: null
  });
  const { sheetFilters } = useSheetFilterContext();
  const handleFilterSearchInput = async (event) => {
    try {
      event.stopPropagation();
      const value = event?.target?.value
      if (value === "") {
        setSearchOptionsState((state) => ({ ...state, options: [], loading: false }))
        return
      }
      let filterQuery = [{
        member: filter?.member,
        operator: 'contains',
        values: [value]
      }]
      let query = {}
      if (filter?.dataSetType === 'MEASURE') {
        query['measures'] = [filter?.member]
      }
      if (filter?.dataSetType === "DIMENSION") {
        query['dimensions'] = [filter?.member]
      }
      query.filters = filterQuery
      setSearchOptionsState((state) => ({ ...state, loading: true }));
      let filters = sheetFilters?.filter(_filter => _filter?.member === filter?.relevantTo);
      filters = filters?.map(_filter => {
        return {
          member: _filter?.member,
          operator: 'equals',
          values: _filter?.values
        }
      });
      if (filters?.length > 0) {
        query.filters = [...query.filters, ...filters]
      }
      const searchValues = await getDataFromCube(null, null, null, "custom_query_data", query)
      const options = searchValues?.map(item => item[filter?.member]);
      setSearchOptionsState((state) => ({ ...state, options }))
    } catch (error) {
      setSearchOptionsState((state) => ({ ...state, error: error.message }))
    } finally {
      setSearchOptionsState((state) => ({ ...state, loading: false }))
    }
  };
  const debouncedFetchFilterOptions = _.debounce((event) => {
    if (optionsState.options.length)
      handleFilterSearchInput(event);
  }, 1000);
  return [searchOptionsState, debouncedFetchFilterOptions];
}

function useDebouncedFunction(toDebounceFunction = () => { }, delayDuration = 1000) {
  const timeOutRef = useRef(null);
  const debouncedFunction = useCallback(
    (...args) => {
      clearTimeout(timeOutRef.current);
      timeOutRef.current = setTimeout(() => {
        toDebounceFunction(...args);
      }, delayDuration);
    }
  );
  return debouncedFunction;
}

const SheetFilterContext = createContext();
function SheetFilterContextProvider({ children }) {
  const { currentSheet, applyFiltersOnCurrentSheet } = useDashboardContext();
  const [sheetFilters, setSheetFilters] = useState([]);
  const [sheetFilterValues, setSheetFilterValues] = useState({});
  useEffect(() => {
    if (!currentSheet?.sheetFilter?.length) {
      if (sheetFilters.length > 0) setSheetFilters([]);
      if (sheetFilterValues.length > 0) setSheetFilterValues({});
      return
    }
    let _sheetFilterValues = {};
    const _sheetFilters = currentSheet?.sheetFilter?.map((filter, i) => {
      let isCascadedHidden = false;
      if (filter.relevantTo && filter.relevantTo !== '') {
        const relevantOption = currentSheet?.sheetFilter?.filter(opt => opt?.listType).find(opt => opt?.member === filter?.relevantTo);
        if (relevantOption?.values?.length == 0) {
          isCascadedHidden = true;
        }
      }
      _sheetFilterValues[i] = filter.values ?? [];
      return {
        ...filter,
        filterIndex: i,
        isCascadedHidden
      }
    });

    setSheetFilterValues(_sheetFilterValues);
    setSheetFilters(_sheetFilters);
  }, [currentSheet?.sheetFilter]);

  const sheetFilterValueChangeHandler = async ({ values, filterIndex, filterMetaData, apply }) => {
    //console.log(values,filterIndex)
    setSheetFilterValues(prev => ({
      ...prev,
      [filterIndex]: values
    }));

    if (filterMetaData) {
      sheetFilters[filterIndex] = {
        ...sheetFilters[filterIndex],
        ...filterMetaData
      }
      setSheetFilters([...sheetFilters]);
    }
    if (apply) {
      await applyFiltersOnCurrentSheet({
        sheetFilter: {
          ...sheetFilters[filterIndex],
          values: values ?? []
        },
        filterIndex
      });
    }
  }

  const applyFilter = async ({ filterIndex, filterMetaData }) => {
    // if (!sheetFilterValues[filterIndex]?.length) return
    await applyFiltersOnCurrentSheet({
      sheetFilter: {
        ...sheetFilters[filterIndex],
        values: sheetFilterValues[filterIndex] ?? [],
        ...filterMetaData
      },
      filterIndex
    });
  }

  const clearFilter = async ({ filterIndex, filterMetaData }) => {
    if (!sheetFilterValues[filterIndex]?.length && !sheetFilters[filterIndex]?.values?.length) return
    let sheetFilter = sheetFilters[filterIndex];
    if (filterMetaData) {
      sheetFilter = {
        ...sheetFilter,
        ...filterMetaData
      }
    }
    sheetFilter.values = [];
    if (filterMetaData?.dateFilterProps?.selectedTimePeriod) {
      sheetFilter.dateFilterProps.selectedTimePeriod = ''
    }
    applyFiltersOnCurrentSheet({
      sheetFilter: {
        ...sheetFilter,
        values: []
      },
      filterIndex
    });
  }

  const clearFilterNotApplied = async ({ filterIndex, filterMetaData }) => {
    if (filterMetaData) {
      let _sheetFilters = structuredClone(sheetFilters);
      _sheetFilters[filterIndex] = {
        ..._sheetFilters[filterIndex],
        ...filterMetaData
      }
      setSheetFilters(_sheetFilters)
    }
    if (!sheetFilterValues[filterIndex]?.length) return
    setSheetFilterValues({ ...sheetFilterValues, [filterIndex]: sheetFilters[filterIndex]?.values ?? [] });
  }

  const contextValues = useMemo(
    () => {
      return {
        applyFilter,
        clearFilter,
        sheetFilters,
        sheetFilterValues,
        clearFilterNotApplied,
        sheetFilterValueChangeHandler,
        currentSheet
      }
    },
    [
      applyFilter,
      clearFilter,
      sheetFilters,
      sheetFilterValues,
      clearFilterNotApplied,
      sheetFilterValueChangeHandler,
      currentSheet
    ]
  )

  return (
    <SheetFilterContext.Provider
      value={contextValues}
    >
      {children}
    </SheetFilterContext.Provider>
  )
}

function useSheetFilterContext() {
  const context = useContext(SheetFilterContext);
  if (!context) {
    throw new Error('useSheetFilterContext must be used within SheetFilterContextProvider')
  }
  return context;
}

export default (props) => {
  const isMobileView = useMemo(() => window.innerWidth < 500, [])
  return (
    <SheetFilterContextProvider>
      {
        isMobileView
          ? <MobileViewSheetFilter editFilterComponents={props.editFilterComponents} />
          : <DesktopViewSheetFilter editFilterComponents={props.editFilterComponents} />
      }
    </SheetFilterContextProvider>
  )
}